import PageSettings from 'client/components/core/Sidebar/components/Settings/PageSettings'
import useManagement from 'client/hooks/useManagement'
import usePresentPage, {
  selectors as pageSelectors,
} from 'client/hooks/usePresentPage'
import { selectors } from 'client/reducers/managementReducer'
import { ManagementState, usePage } from 'client/store'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { EntitiesStructure } from 'common/types/Page'
import React, { memo } from 'react'
import { PagesManagement } from 'src/editor/layout/sidebar/pages-management'
import { WebsiteBlogSettings } from 'src/editor/layout/sidebar/website-blog-settings'
import { Library } from './library'
import { PopupManagement } from './popup-management'
import { EntitySettings } from './settings/entity-settings'
import { SettingsOverlayContextProvider } from './settings/settings-overlay-context'
import { WebsiteSettings } from './website-settings'
import { WebsiteStylesSettings } from './website-styles-settings'

const combinedSidebarSelector = (state: ManagementState) => ({
  editingId: selectors.getEditingId(state),
  isPopupActive: selectors.isPopupActive(state),
  isPopupManagement: selectors.isPopupManagement(state),
  isWebsiteStylesSettings: selectors.isWebsiteStylesSettings(state),
  isWebsiteBlogSettings: selectors.isWebsiteBlogSettings(state),
  isPagesManagementActive: selectors.isPagesManagementActive(state),
  isPageEditing: selectors.isPageEditing(state),
  isWebsiteSettings: selectors.isWebsiteSettings(state),
  isWebsiteLoginPageSettings: selectors.isWebsiteSettings(state),
})

export const SidebarContent = memo(() => {
  const sidebarState = useManagement(combinedSidebarSelector)

  const isWebsiteLoginPage =
    usePage(pageSelectors.getPageType) === PageTypeEnum.WebsiteLogin
  const {
    editingId,
    isPopupActive,
    isPopupManagement,
    isWebsiteStylesSettings,
    isWebsiteBlogSettings,
    isPagesManagementActive,
    isPageEditing,
    isWebsiteSettings,
  } = sidebarState

  const entity = usePresentPage((p: { entities: EntitiesStructure }) =>
    pageSelectors.getEntityById(p, editingId),
  )

  if (entity) {
    return (
      <SettingsOverlayContextProvider>
        <EntitySettings entity={entity} />
      </SettingsOverlayContextProvider>
    )
  }

  if (isPageEditing) {
    return (
      <SettingsOverlayContextProvider>
        <PageSettings />
      </SettingsOverlayContextProvider>
    )
  }
  if (isWebsiteSettings) {
    return <WebsiteSettings />
  }

  if (isPopupManagement && !isPopupActive) {
    return <PopupManagement />
  }

  if (isWebsiteStylesSettings) {
    return <WebsiteStylesSettings />
  }

  if (isWebsiteBlogSettings) {
    return <WebsiteBlogSettings />
  }

  if (isPagesManagementActive || isWebsiteLoginPage) {
    return <PagesManagement />
  } else {
    return <Library />
  }
})
